import styles from './FJAIVideoGeneratorProgress.module.less';
import CoinBtnBase64 from '../../../../assets/base64/cion-btn.js';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJAppConstant from '../../../../constants/FJAppConstant.js';
import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const JumpDesc = props => {
    const { onClick } = props;

    const decRef = useRef(null);
    useEffect(() => {
        const spanDom = decRef.current?.getElementsByTagName('span')[1];
        if (spanDom) {
            spanDom.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
                onClick();
            });
        }
    }, [onClick]);

    return (
        <div
            className={styles.wait_time}
            dangerouslySetInnerHTML={{
                __html: FJLocalStore._(
                    'estimate-wait-time-you-can-still-view-it-in-the-history-after-closing-the-page',
                ),
            }}
            ref={decRef}
        />
    );
};

JumpDesc.propTypes = {
    onClick: PropTypes.func,
};

const FJAIVideoGeneratorProgress = props => {
    const { getCredit, imgUrl, status, reGenerate, jumpHistory, creditNumber } = props;
    return (
        <div className={styles.box}>
            <div className={styles.inner}>
                {imgUrl && (
                    <>
                        <img className={styles.bk_img} src={imgUrl} alt='' />
                        <div className={styles.mask} />
                    </>
                )}

                <div className={styles.content}>
                    {status === FJAppConstant.RUNNING && (
                        <>
                            <div className={styles.title}>{FJLocalStore._('generating_')}</div>
                            <div className={styles.progress}>
                                <div className={styles.line} />
                            </div>
                            <JumpDesc onClick={jumpHistory} />
                            {creditNumber < 20 && (
                                <div className={styles.btn} onClick={getCredit}>
                                    <img src={CoinBtnBase64} alt='' />
                                    {FJLocalStore._('get-credits')}
                                </div>
                            )}
                        </>
                    )}
                    {status === FJAppConstant.ERROR && (
                        <>
                            <div className={styles.error_text}>
                                {FJLocalStore._('failed-to-generate-video-because-of-some-unknown-errors')}
                            </div>
                            <div className={styles.retry_btn} onClick={reGenerate}>
                                {FJLocalStore._('retry')}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

FJAIVideoGeneratorProgress.propTypes = {
    getCredit: PropTypes.func,
    imgUrl: PropTypes.string,
    status: PropTypes.string,
    reGenerate: PropTypes.func,
    jumpHistory: PropTypes.func,
    creditNumber: PropTypes.number,
};

export default FJAIVideoGeneratorProgress;
